import React, { useEffect, useState } from 'react';

import {
  SongPresentationContainer,
  AlbumCoverGrid,
  SongAssetsContainer,
  GridItems,
  GridImages,
  ArtistName,
  SongName,
  GetSampleButton,
  ProjectDescriptionContainer,
  ProjectDescriptionText,
  ActionsButtonContainer,
  ActionButton,
  ActionLogo,
  CommasLogoStyled,
  SongAssetListContainer,
  PriceContainer,
  FromStyled,
  PriceStyled,
  SongAssetListCenterContainer,
  ProgressBar,
  PlayButton
} from '../../styles/ProjectPresentation.styled';

import { SamplesBadge } from '../SamplesBadge/SamplesBadge';

import AlbumCover from '../../assets/Images/AlbumCoverImage.png';
import ExportLogo from '../../assets/Logos/Export.svg';
import PlayLogo from '../../assets/Logos/Play.svg';
import PauseLogo from '../../assets/Logos/Pause.svg';
import MuteLogo from '../../assets/Logos/SpeakerHigh.svg';
import MutedLogo from '../../assets/Logos/SpeakerX.svg';
import CommasLogo from '../../assets/Logos/Commas.svg';

import SongPreview from '../../assets/SoundPreview/RMZ_Surfside_Preview10.mp3';
import { waveform_is_bought } from '../../utils/Waveform_array';

export const ProjectPresentation = (props: any) => {
  const [audio] = useState(new Audio(SongPreview));
  const [playingPreview, setPlayingPreview] = useState<boolean>(false);
  const [mute, setMute] = useState<boolean>(false);
  const [PreviewcurrentTime, setPreviewcurrentTime] = useState<number>(0);

  const togglePlayPreview = () => {
    setPlayingPreview(!playingPreview);
  };

  const toggleMute = () => {
    audio.muted = !mute;
    setMute(!mute);
  };

  const handleGetRandomSample = () => {
    do {
      var sampleSelected = Math.floor(
        Math.random() * waveform_is_bought.length
      );
      console.log('sample randomly selected :', sampleSelected);
      console.log(
        'waveform_is_bought[sampleSelected] :',
        waveform_is_bought[sampleSelected]
      );
    } while (waveform_is_bought[sampleSelected]);

    props.onClick(sampleSelected);
  };

  useEffect(() => {
    playingPreview ? audio.play() : audio.pause();
  }, [playingPreview]);

  useEffect(() => {
    audio.addEventListener('ended', () => {
      setPlayingPreview(false);
      setTimeout(() => setPreviewcurrentTime(0), 200);
    });
    audio.addEventListener('timeupdate', () => {
      setPreviewcurrentTime(Math.round(audio.currentTime * 10) / 10);
    });
    return () => {
      audio.removeEventListener('ended', () => {
        setPlayingPreview(false);
        setTimeout(() => setPreviewcurrentTime(0), 1000);
      });
      audio.removeEventListener('timeupdate', () => {
        setPreviewcurrentTime(Math.round(audio.currentTime * 10) / 10);
      });
    };
  }, []);

  return (
    <SongPresentationContainer>
      <ProjectDescriptionContainer>
        <CommasLogoStyled src={CommasLogo} />
        <ProjectDescriptionText>
          Super stoked on this new NFT release. Hope you’ll dig it. <br />
          <br />
          You will hear @ianewingmusic on the drums, @leonphal_ on the saxophone
          and @nico.felices playing the bass.
          <br />
          <br /> Surfside is inspired by the modern Jazz/Soul scene of
          California, and the surf culture. A smooth blend of Jazz, Hip-Hop &
          Soul. <br />
          <br />
          My songs feature good friends of mine and talented musicians I am
          lucky to be around. Everything is recorded, mixed and produced by
          myself. <br />
          <br />
          Have a nice day everyone!
        </ProjectDescriptionText>
        <ActionsButtonContainer>
          <ActionButton>
            <ActionLogo src={ExportLogo} alt="Export" />
          </ActionButton>
          <PlayButton onClick={togglePlayPreview}>
            <ProgressBar
              audioProgress={
                PreviewcurrentTime
                  ? (Math.round(PreviewcurrentTime * 10) /
                      10 /
                      (Math.round(audio.duration * 10) / 10)) *
                    100
                  : 0
              }
              isPlaying={playingPreview}
            />
            {playingPreview ? (
              <ActionLogo src={PauseLogo} alt="Pause" />
            ) : (
              <ActionLogo src={PlayLogo} alt="Play" />
            )}
          </PlayButton>
          <ActionButton onClick={toggleMute}>
            {mute ? (
              <ActionLogo src={MutedLogo} alt="Muted" />
            ) : (
              <ActionLogo src={MuteLogo} alt="Mute" />
            )}
          </ActionButton>
        </ActionsButtonContainer>
      </ProjectDescriptionContainer>
      <SongAssetsContainer>
        <SongAssetListContainer>
          <ArtistName>RMZ</ArtistName>
          <SamplesBadge
            title="SAMPLES SOLD"
            number={waveform_is_bought.filter((x) => x === true).length}
            totalNumber={180}
          />
        </SongAssetListContainer>
        <SongAssetListCenterContainer>
          <SongName>Surfside</SongName>
          <PriceContainer>
            <FromStyled>From</FromStyled>
            <PriceStyled>0,5 ETH</PriceStyled>
          </PriceContainer>
        </SongAssetListCenterContainer>
        <AlbumCoverGrid>
          <GridItems />
          <GridItems />
          <GridItems />
          <GridItems />
          <GridItems>
            <GridImages src={AlbumCover} alt={'Album cover image'} />
          </GridItems>
          <GridItems />
          <GridItems />
          <GridItems />
          <GridItems />
        </AlbumCoverGrid>
        <GetSampleButton onClick={handleGetRandomSample}>
          GET RANDOM NFT SAMPLE
        </GetSampleButton>
      </SongAssetsContainer>
    </SongPresentationContainer>
  );
};
